import { render, staticRenderFns } from "./Custom.vue?vue&type=template&id=0a8de5fe&scoped=true&"
import script from "./Custom.vue?vue&type=script&lang=js&"
export * from "./Custom.vue?vue&type=script&lang=js&"
import style0 from "./Custom.vue?vue&type=style&index=0&id=0a8de5fe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8de5fe",
  null
  
)

export default component.exports